import React from 'react';
import { getDisplayPrice, formatPrice } from '../../../../utils/priceUtils.js';

const PackageDetailsCard = ({
  event,
  packageData,
  attendeeCount,
  canDecrement,
  onIncrement,
  onDecrement,
  onPurchaseClick,
  onAttendeeCountChange,
}) => {
  if (!event || !packageData) return null;

  return (
    <div className="ticket-card ticket-card--muted">
      <div className="ticket-package-header">
        <h4 className="ticket-package-title">
          {packageData.name || packageData.selectType || 'Package Details'}
        </h4>
        <div className="ticket-quantity-inline ticket-quantity-inline--top-right">
          <button
            type="button"
            className={
              canDecrement
                ? 'ticket-quantity-inline__button'
                : 'ticket-quantity-inline__button ticket-quantity-inline__button--disabled'
            }
            onClick={canDecrement ? onDecrement : undefined}
          >
            -
          </button>
          <div className="ticket-quantity-inline__input-wrapper">
            <input
              type="number"
              min={1}
              className="ticket-quantity-inline__input"
              value={attendeeCount}
              onChange={(e) =>
                onAttendeeCountChange && onAttendeeCountChange(e.target.value)
              }
            />
            <span className="ticket-quantity-inline__label">
              Attendees
            </span>
          </div>
          <button
            type="button"
            className="ticket-quantity-inline__button"
            onClick={onIncrement}
          >
            +
          </button>
        </div>
      </div>
      <p className="ticket-package-description">
        {packageData.details || event.description || 'No package details available.'}
      </p>
      <ul className="ticket-package-features">
        {packageData.Duration && (
          <li className="ticket-package-feature">
            <span>⏱️</span>
            <span>
              <strong>Duration:</strong> {packageData.Duration}
            </span>
          </li>
        )}
        {packageData.DateChoices && (
          <li className="ticket-package-feature">
            <span>📅</span>
            <span>
              <strong>Date Options:</strong> {packageData.DateChoices}
            </span>
          </li>
        )}
        {packageData.location && (
          <li className="ticket-package-feature">
            <span>📍</span>
            <span>
              <strong>Package Location:</strong> {packageData.location}
            </span>
          </li>
        )}
        {packageData.PackageType && (
          <li className="ticket-package-feature">
            <span>🎦</span>
            <span>
              <strong>Package Type:</strong> {packageData.PackageType}
            </span>
          </li>
        )}
        {packageData.TypeOptions && (
          <li className="ticket-package-feature">
            <span>⚙️</span>
            <span>
              <strong>Type Options:</strong> {packageData.TypeOptions}
            </span>
          </li>
        )}
        {packageData.Day && (
          <li className="ticket-package-feature">
            <span>📆</span>
            <span>
              <strong>Day(s):</strong> {packageData.Day}
            </span>
          </li>
        )}
      </ul>
      <div className="ticket-package-price">
        {formatPrice(getDisplayPrice(packageData.price || packageData.pricing || '0.00') * attendeeCount)}
      </div>
    </div>
  );
};

export default PackageDetailsCard;
